import React from 'react';
import { ChevronDownIcon, ChevronUpIcon, useThemeProps } from 'native-base';
import { AccordionItemContext } from './Context';
// import { useHasResponsiveProps } from '../../../hooks/useHasResponsiveProps';

const AccordionIcon = ({ ...props }, ref) => {
  const { isOpen } = React.useContext(
    AccordionItemContext
  );
  const { ...newProps } = useThemeProps('AccordionIcon', props);
  //TODO: refactor for responsive prop
  // if (useHasResponsiveProps(props)) {
  //   return null;
  // }
  return isOpen ? (
    <ChevronUpIcon color="white" {...newProps} ref={ref} />
  ) : (
    <ChevronDownIcon {...newProps} ref={ref} />
  );
};

export default React.memo(React.forwardRef(AccordionIcon));
